import React from 'react';
import { StyleSheet } from 'react-native';
import { Typography, Box, Skeleton } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { workProfileSectionTitleSx } from '../../constants/workProfileSectionTitle';
import { strings } from '../../constants';

const ProjectActivityCardLoadingState = () => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);

    return (
        <Box
            style={styles.flexColumn}
            sx={{
                width: '100%',
                gap: '25px',
                backgroundColor: '#1a1a1a',
                height: 'fit-content',
                padding: { xs: '15px', sm: '30px' },
                borderRadius: '14px',
                position: 'relative',
                border: '1px solid rgba(255,255,255,0.08)',
                overflow: 'hidden',
            }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', width: '100%', mb: 0 }}>
                <Typography sx={{ ...workProfileSectionTitleSx(themeStyle), mb: 1.25 }}>
                    {strings.recent_activities}
                </Typography>
                <Box
                    component="hr"
                    sx={{
                        width: '100%',
                        border: 'none',
                        borderTop: `1px solid ${theme[themeStyle].darkGray60}`,
                        opacity: 1,
                        m: 0,
                    }}
                />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    width: '100%',
                    pt: 1,
                }}>
                <Skeleton
                    variant="rounded"
                    width={44}
                    height={44}
                    sx={{
                        bgcolor: theme[themeStyle].darkGray60,
                        flexShrink: 0,
                        borderRadius: '8px',
                    }}
                />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Skeleton
                        variant="text"
                        sx={{ fontSize: '1.1rem', bgcolor: theme[themeStyle].darkGray60, width: '45%' }}
                    />
                    <Skeleton
                        variant="text"
                        sx={{ fontSize: '0.85rem', bgcolor: theme[themeStyle].darkGray60, width: '35%' }}
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'block', width: '100%', mt: { xs: 2, sm: 3 } }}>
                <Skeleton
                    variant="rounded"
                    sx={{
                        fontSize: '1rem',
                        backgroundColor: theme[themeStyle].darkGray60,
                        width: '100%',
                        aspectRatio: '16 / 9',
                        marginBottom: 0,
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', width: '100%', gap: 1, px: 0, pt: 2, pb: 0.5, alignItems: 'center' }}>
                <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: theme[themeStyle].darkGray60 }} />
                <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: theme[themeStyle].darkGray60 }} />
                <Skeleton variant="text" sx={{ flex: 1, bgcolor: theme[themeStyle].darkGray60 }} />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    mt: 1,
                    py: 2,
                    px: 0,
                    bgcolor: '#1a1a1a',
                    borderTop: '1px solid rgba(255,255,255,0.04)',
                }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Skeleton variant="rounded" width={56} height={28} sx={{ bgcolor: theme[themeStyle].darkGray60 }} />
                    <Skeleton variant="rounded" width={56} height={28} sx={{ bgcolor: theme[themeStyle].darkGray60 }} />
                    <Skeleton variant="rounded" width={72} height={28} sx={{ bgcolor: theme[themeStyle].darkGray60 }} />
                </Box>
            </Box>
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
        },
    });

export { ProjectActivityCardLoadingState };
